import PropTypes from 'prop-types';

import FeedPostBlur from './FeedPostBlur';
import Flux from '../../flux/Flux';
import VXShaka from '../VXShaka/VXShaka';
import { postClipType, postType, tippingGoalType } from './FeedHelper';
import FeedPostNeedAction from './FeedPostNeedAction';
import { getButton } from './FeedHelper';
import { Fragment, PureComponent } from 'react';

class FeedPostVideo extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			videoIsLoaded: false,
			src: '',
		};

		this.onClickOpen = this.onClickOpen.bind(this);
		this.onLoadedMetadata = this.onLoadedMetadata.bind(this);
		this.onDoubleClick = this.onDoubleClick.bind(this);
		this.onPlayChange = this.onPlayChange.bind(this);

		this.videoRef = null;

		this.playObserver = new IntersectionObserver(
			(entries) => {
				const isIntersectingOrPlayable =
					entries[0].isIntersecting || (this.props.isOverlay && !this.state.src && this.props.clip.sources.length > 0);
				if (isIntersectingOrPlayable) {
					setTimeout(() => {
						if (this.shakaRef && this.shakaRef.video.paused) {
							!this.props.isOverlay && this.shakaRef && this.shakaRef.video.play();
						}
						Flux.Feed.setPlayingVideoId(this.props.id);
					});
				} else {
					!this.props.isOverlay && this.shakaRef && this.shakaRef.video.pause();
				}
			},
			{ rootMargin: '-25%' },
		);

		this.loadObserver = new IntersectionObserver(
			(entries) => {
				const isIntersectingOrPlayable =
					entries[0].isIntersecting || (this.props.isOverlay && !this.state.src && this.props.clip.sources.length > 0);
				if (isIntersectingOrPlayable && !this.state.src && this.props.clip.sources.length > 0) {
					this.setState({ src: this.props.clip.sources[0].src });
				}
			},
			{ rootMargin: this.props.isMobile ? '100%' : '50%' },
		);
	}

	componentDidMount() {
		if (this.videoRef) {
			this.playObserver.observe(this.videoRef);
			this.loadObserver.observe(this.videoRef);
		}
		Flux.Feed.addVideoPlayChangeListener(this.onPlayChange);
	}

	componentDidUpdate() {
		if (
			(this.props.isMobile || this.props.isTablet) &&
			(this.props.overlayType === 'comments' || this.props.isTabletOverlayComment) &&
			this.shakaRef &&
			this.shakaRef.video
		) {
			this.shakaRef.video.pause();
		}
	}

	componentWillUnmount() {
		Flux.Feed.removeVideoPlayChangeListener(this.onPlayChange);
	}

	onPlayChange(postId, isMuted) {
		if (postId === this.props.id) {
			if (!this.props.isMobile) {
				this.shakaRef.video.muted = isMuted;
			}
		} else {
			!this.props.isOverlay && this.shakaRef && this.shakaRef.video.pause();
		}
	}

	setVideoRef(ref) {
		if (ref) {
			this.videoRef = ref;
			this.playObserver.observe(this.videoRef);
			this.loadObserver.observe(this.videoRef);
		}
	}

	onClickOpen() {
		this.props.isOverlay ? Flux.Feed.toggleOverlay(this.props.id) : Flux.Feed.toggleOverlay(this.props.id, Flux.Constants.Feed.OverlayTypes.ALL);
	}

	onLoadedMetadata() {
		this.setState({ videoIsLoaded: true });
	}

	onDoubleClick() {
		Flux.Guest.isLoggedIn() && Flux.Feed.toggleLike(this.props.id);
	}

	setShakaRef(ref) {
		if (ref) {
			this.shakaRef = ref;
			if (ref.video) {
				ref.video.addEventListener('volumechange', () => {
					Flux.Feed.setVideoMute(ref.video.muted);
				});
			}
			if (!ref.video.currentTime) {
				ref.video.currentTime = 0;
			}
		}
	}

	getContent() {
		let content;
		const posterUrl = this.props.clip.poster ? this.props.clip.poster.url : '';
		const needsTippingGoal = this.props.tippingGoal && !this.props.tippingGoal.achieved;
		if (this.props.clip.avsRequired) {
			return <FeedPostNeedAction poster={posterUrl} actorId={parseInt(this.props.model.id)} tippingGoal={this.props.tippingGoal} />;
		} else if (this.props.needBuy || needsTippingGoal) {
			const maxHeight = this.props.isMobile ? 450 : 700;
			const style = { height: this.props.clip.height < maxHeight ? this.props.clip.height : maxHeight };
			return (
				<div className="feed-video" style={style}>
					{posterUrl && <FeedPostBlur imgUrl={posterUrl} isOverlay={this.props.isOverlay} />}
				</div>
			);
		} else {
			const videoType = this.props.clip.sources.length > 0 ? this.props.clip.sources.type : '';
			const maxHeight = this.props.isMobile ? 450 : 700;
			const style = { height: this.props.clip.height < maxHeight ? this.props.clip.height : maxHeight };
			content = (
				<div className="feed-video" ref={(ref) => this.setVideoRef(ref)} style={style}>
					{posterUrl && <FeedPostBlur imgUrl={posterUrl} isOverlay={this.props.isOverlay} />}
					<VXShaka
						onLoadedMetadata={this.onLoadedMetadata}
						src={this.state.src}
						videoType={videoType}
						useHlsJs={true}
						isLivestream={false}
						autoplay={false}
						controlsVisible={true}
						ref={(ref) => this.setShakaRef(ref)}
						muted={this.props.isMobile ? true : Flux.Feed.getVideoMute()}
						onFullscreenClick={this.props.isOverlay || this.props.isMobile ? null : this.onClickOpen}
						showFullscreen={Flux.Guest.isLoggedIn()}
						onDoubleClick={this.onDoubleClick}
						showBigPlayButton={true}
						initialShowUI={false}
						forceUnmute={this.props.isMobile ? false : !Flux.Feed.getVideoMute()}
					/>
				</div>
			);
		}

		return (
			<Fragment>
				{this.state.videoIsLoaded && posterUrl && <FeedPostBlur imgUrl={posterUrl} isOverlay={this.props.isOverlay} />}
				{this.props.isOverlay && this.props.isTablet && !this.props.isLandscape && (
					<i
						className="icon -icon-close-line modal__btn-close"
						onClick={() => {
							Flux.Feed.toggleOverlay(this.props.id);
						}}
					></i>
				)}
				{content}
				{!Flux.Guest.isLoggedIn() &&
					this.state.videoIsLoaded &&
					!this.props.isOverlay &&
					getButton({ isVideo: true, actorId: parseInt(this.props.model.id), postId: this.props.id, price: this.props.price })}
			</Fragment>
		);
	}

	render() {
		return this.getContent();
	}
}

FeedPostVideo.propTypes = {
	isOverlay: PropTypes.bool,
	isTablet: PropTypes.bool,
	isLandscape: PropTypes.bool,
	isTabletOverlayComment: PropTypes.bool,
	needBuy: PropTypes.bool,
	clip: PropTypes.shape(postClipType),
	tippingGoal: PropTypes.shape(tippingGoalType),
	...postType,
};

export default FeedPostVideo;
